import React from "react";
import DailyActivityListComponent from "../components/report/DailyActivityListComponent";

export default function DailyActivity() {
  return (
    <div>
      <DailyActivityListComponent />
    </div>
  );
}
